// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDi8OumcqEdqqndK4KtYN05iGfn-vCwZWU",
  authDomain: "elpoderdelasideas-3b778.firebaseapp.com",
  projectId: "elpoderdelasideas-3b778",
  storageBucket: "elpoderdelasideas-3b778.appspot.com",
  messagingSenderId: "1030162835451",
  appId: "1:1030162835451:web:975d61729575e4b6e60d5e",
  measurementId: "G-JC6FFXM340"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/elpoderdelasideas-3b778.appspot.com/o/'